import moment from 'moment';
import { ColumnTypeKanban } from '~/utils/interface/common';
import { IScheduleList } from '~/utils/interface/schedule';

export const convertScheduleKanban = (
  data: IScheduleList[],
  startDate: string,
  endDate: string
): ColumnTypeKanban<IScheduleList>[] => {
  const start = moment(startDate).startOf('day');
  const end = moment(endDate).endOf('day');

  const acc: Record<string, ColumnTypeKanban<IScheduleList>> = {};
  let current = start.clone();
  while (current.isSameOrBefore(end)) {
    const dateKey = current.format('YYYY-MM-DD');
    acc[dateKey] = {
      uuid: dateKey,
      id: dateKey,
      date: current.format('MM/DD'),
      name: current.format('dddd'),
      items: [],
    };
    current.add(1, 'day');
  }

  data.forEach((job) => {
    const jobDate = moment(job.startDate);
    if (jobDate.isBetween(start, end, undefined, '[]')) {
      const dateKey = jobDate.format('YYYY-MM-DD');
      acc[dateKey]?.items.push(job);
    }
  });

  Object.values(acc).forEach((col) => {
    col.items.sort((a, b) => {
      if (a.position == null && b.position == null) return 0;
      if (a.position == null) return 1;
      if (b.position == null) return -1;
      return a.position - b.position;
    });
  });

  return Object.values(acc);
};
